import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="mt-2 text-muted-foreground">Page not found.</p>
      <Link to="/" className="mt-4 text-sm font-medium text-primary hover:underline">
        Back to dashboard
      </Link>
    </div>
  )
}
